import React, { useState } from 'react';
import { Modal, Button, Form, InputGroup, Alert } from 'react-bootstrap';
import { FaCopy } from 'react-icons/fa';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API_URL = process.env.REACT_APP_API_URL || 'https://wfshare.wishfin.com/api';
const API_KEY = process.env.REACT_APP_API_KEY || '';

const ShareModal = ({ show, onHide, filePath }) => {
  const { user } = useAuth();
  const [expirationHours, setExpirationHours] = useState(24);
  const [shareLink, setShareLink] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const handleCreateShare = async () => {
    try {
      setLoading(true);
      setError('');
      
      // Create the share link
      const response = await axios.post(
        `${API_URL}/share?user_id=${user.id}`,
        {
          file_path: filePath,
          expiration_hours: parseInt(expirationHours)
        },
        {
          headers: {
            'x-api-key': API_KEY,
            'Content-Type': 'application/json'
          }
        }
      );
      
      // Generate full URL
      const baseUrl = window.location.origin;
      const shareUrl = `${baseUrl}${response.data.url}`;
      setShareLink(shareUrl);
    } catch (err) {
      console.error('Share creation error:', err);
      const errorMessage = err.response?.data?.detail || 'Failed to create share link';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };
  
  const handleCopyLink = () => {
    navigator.clipboard.writeText(shareLink);
  };
  
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Share File</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Create a temporary link to share: <strong>{filePath?.split('/').pop()}</strong></p>
        
        {error && <Alert variant="danger">{error}</Alert>}
        
        <Form.Group className="mb-3">
          <Form.Label>Link expiration</Form.Label>
          <Form.Select
            value={expirationHours}
            onChange={(e) => setExpirationHours(e.target.value)}
          >
            <option value="1">1 hour</option>
            <option value="6">6 hours</option>
            <option value="12">12 hours</option>
            <option value="24">24 hours</option>
            <option value="72">3 days</option>
            <option value="168">7 days</option>
          </Form.Select>
        </Form.Group>
        
        {shareLink && (
          <div className="share-link-container">
            <Form.Label>Share Link (expires in {expirationHours} hours)</Form.Label>
            <InputGroup>
              <Form.Control value={shareLink} readOnly />
              <Button variant="outline-secondary" onClick={handleCopyLink}>
                <FaCopy /> Copy
              </Button>
            </InputGroup>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button 
          variant="primary" 
          onClick={handleCreateShare} 
          disabled={loading || !!shareLink}
        >
          {loading ? 'Creating...' : 'Create Share Link'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ShareModal;
